import React,{Component} from 'react';
import classnames from 'classnames';

import Workflow from './Workflow';
import Loading from '../../common/Loading';
import './index.scss';

function accordionData(auth) {
  const { domain, role } = auth;
  const CS_ROLES = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];

  const customizationValues = [];

  if (CS_ROLES.includes(role)) {
    customizationValues.push({
      title: 'Voice AI Setup',
      description: '',
      component: (props, onValueChange, onSave, onCancel, removeLogo, auth, business, voiceaiconfig, softwares) => (
        <Workflow
          props={props}
          onValueChange={onValueChange}
          onSave={onSave}
          onCancel={onCancel}
          removeLogo={removeLogo}
          auth={auth}
          business={business}
          voiceaiconfig={voiceaiconfig}
          softwares={softwares}
        />
      )
    });
  }

  return customizationValues;
}

class ConversationList extends Component {
  
  constructor(props){
    super(props);
    this.state ={
      accordion: -1,
      greetings:'Hi there  How can i help you today?',
      file_name:'',
      global_logo_file:'',
      business_name: '',
      assistant_name:'Studio Assiatant',
      actioncolor:'#BB2C2C',
      brandcolor:'#000000',
      require_email:false,
      email_capture_message:'',
      collapse_on_start:true,
      logo:''
    }
  }
  componentDidMount =()=>{
    
  }
  componentWillReceiveProps(nextProps){

  }
  openAccordion = (index)=>{
    if(index!==this.state.accordion){
    this.setState({
      accordion:index
    })
    }else{
      this.setState({
        accordion:-1
      })
    }
  }

  onValueChange =(event,target)=>{
    if(target === 'actioncolor'|| target==='brandcolor'){
      this.setState({
        [target]:event.hex
      })
    }else{
    this.setState({
      [target]:event.target.value
    })
    if(target==='collapse_on_start'){
      this.onSave(event,'collapse');
    }
    }
  }
  removeLogo = ()=>{
    this.setState({
      global_logo_file:null,
    })
  }
  onCancel =()=>{
    const { webchatpreference } = this.props.webbookingconfig;
      const { booking_widget_personalization} = webchatpreference;
    this.setState({
        global_logo_file: (booking_widget_personalization.logo)?booking_widget_personalization.logo:null,
        actioncolor:  booking_widget_personalization.action_color,
        brandcolor:  booking_widget_personalization.background_color,
        accordion:-1
    })
  }
  onSave =(event)=>{
    console.log(event);
    this.props.updateWeavePhone(event);
  }
  
  render(){
    const {accordion} = this.state;
    const { auth, business, voiceaiconfig, softwares } = this.props;
    
    return (
      accordionData(auth).map((custom,index)=>{
      return (<div key={index}>
              <div className="customization-list" onClick={()=>this.openAccordion(index)}>
                <div className="tabs">
                    <div className={classnames('title',{'selected-accordion': index===accordion})}>{custom.title}</div>
                    <div className="description">{custom.description}</div>
                </div>
                <div className={classnames('acrdn-btn',{'selected-accordion': index===accordion})}><i className="material-icons">keyboard_arrow_down</i></div>
              </div>
              { index===accordion && 
                <><div className='accordion-body'>
          {custom.component(this.state, this.onValueChange, this.onSave, this.onCancel, this.removeLogo, auth, business, voiceaiconfig, softwares)}
                </div>
                </>
              } 
              </div>)
      }
      )
    )

  }
};

export default ConversationList;
